import { RetailUnitSchema, LotterySchema } from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type StopLotteryParams = Static<typeof StopLotteryParamsSchema>;
export const StopLotteryParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
  },
  { additionalProperties: false, $id: 'StopLotteryParams' }
);
